import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { DeleteIcon, EditIcon, PrinterIcon, CloseIcon, SwitchOnIcon, SwitchOffIcon } from 'assets/icons';
import { Table, Pagination, DatePicker, Tooltip, Button, Input, Select, Modal } from 'components';
import { UserService, AuthService, } from 'services';
import moment from 'moment';
import { Globals, Constants, Socket, SocketEvents, checkPermission } from 'utils';
import ModalCreate from './modal-create';

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	state_id: '',
	city_id: '',
}

class User extends React.Component<any> {

	timer: any = undefined;

	state = {
		data: [],
		counter: {
			affiliates: 0,
			businesses: 0,
			clinics: 0,
			medics: 0,
			sellers: 0,
			users: 0,
		},
		page: 1,
		last_page: 1,
		header: [
			'Fecha de registro',
			'Nombres',
			'CI/RIF',
			'Fecha de Nacimiento',
			'Teléfono',
			'Correo',
			'Animales',
			'Estado',
			'Ciudad',
			'Estatus',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		visible_animals: false,
		item: null,
		cities: [],
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.users.rows,
			counter: res.counter,
			last_page: res.users.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		}, () => this.load(true));
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}

	getCities = async () => {
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id,
		});
		this.setState({
			cities: res.cities,
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el usuario?', async () => {
			await UserService.admin.delete({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	suspend = async (item: any) => {
		Globals.confirm(`¿Desea cambiar el estatus del usuario a ${item.status == Constants.USER_STATUS.ACTIVE ? 'Suspendido' : 'Activo'}?`, async () => {
			await UserService.admin.suspend({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			visible_animals: false,
			item: null
		}, () => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	print = async () => {
		const res: any = await UserService.admin.download({
			withoutLoading: true,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	showAnimals = (item?: any) => {
		this.setState({
			visible_animals: !!item,
			item: item
		});
	}

	render() {
		const { counter, visible, visible_animals } = this.state;

		return (
			<div id="admin-register-client">
				<Modal
					className="modal-create-client"
					visible={visible}
					withoutClose={true}
					onClose={() => this.onClose()}
				>
					<ModalCreate
						document_types={this.props.document_types}
						phonecodes={this.props.phonecodes}
						item={this.state.item}
						onClose={() => this.onClose()}
						states={this.props.states}
					/>
				</Modal>

				<Modal
					className="modal-show-animals"
					visible={visible_animals}
					onClose={() => this.onClose()}
					size="sm"
				>
					<UserAnimals
						item={this.state.item}
						onEdit={(e: any) => this.edit(e, this.state.item)}
						onClose={() => this.onClose()}
					/>
				</Modal>

				<div className="row row-filter mb-3" style={{ alignItems: 'flex-end' }}>
					{/* Buscar */}
					<div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={(e: any) => this.change(e)}
						/>
					</div>

					{/* Desde */}
					<div className="col-md-2">
						<DatePicker
							placeholder="Desde"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'since',
										},
									},
								);
							}}
							value={this.state.form.since}
						/>
					</div>

					{/* Hasta */}
					<div className="col-md-2">
						<DatePicker
							placeholder="Hasta"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'until',
										},
									}
								);
							}}
							value={this.state.form.until}
						/>
					</div>

					{/* Estatus */}
					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.status}
							options={[
								{ value: Constants.USER_STATUS.ACTIVE.toString(), label: 'Activos' },
								{ value: Constants.USER_STATUS.INACTIVE.toString(), label: 'Suspendidos' },
							]}
						/>
					</div>

					{/* Estado */}
					<div className="col-md-2">
						<Select
							label="Estado"
							name="state_id"
							onChange={(e: any) =>
								this.change(e, () => {
									this.setState(
										{
											form: {
												...this.state.form,
												city_id: '',
											},
										},
										() => {
											this.getCities();   // cargar ciudades
										},
									);
								})
							}
							value={this.state.form.state_id}
							options={this.props.states.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>

					{/* Ciudad */}
					<div className="col-md-2">
						<Select
							label="Ciudad"
							disabled={!this.state.form.state_id}
							name="city_id"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.city_id}
							options={this.state.cities.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>

					{/* Limpiar */}
					<div className="col-md-3 filter-actions">
						<Button className="btn-filter" onClick={() => this.load(true)}>
							Filtrar
						</Button>

						{this.state.form !== INITIAL_STATE && (
							<Button className="btn-clean" onClick={this.reset}>
								Limpiar
							</Button>
						)}
					</div>
				</div>

				{this.props.tabs}

				<p className="text-right">Usuarios: { counter?.users || 0 }</p>

				<Table
					title="Historial de Registro"
					data={this.state.data.length}
					rightAlign={[10]}
					header={this.state.header}
					titleRight={
						<React.Fragment>
							{
								checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
									<Button className="btn-add" onClick={() => this.print()}>
										<img src={PrinterIcon} alt="Descargar Excel" />
										Descargar Excel
									</Button>
								)
							}
						</React.Fragment>
					}
				>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
								<td>{i.name}</td>
								<td>{i.document_format}</td>
								<td>{i.birthdate ? moment(i.birthdate).format('DD-MM-YYYY') : '--'}</td>
								<td>{i.phonecode?.name}-{i.phone}</td>
								<td>{i.email}</td>
								<td className="text-center">{i.user_animals?.length > 0
									? <button className="show-animals" onClick={() => this.showAnimals(i)}>Ver</button>
									: '--'
								}</td>
								<td>{i.state?.name}</td>
								<td>{i.city?.name}</td>
								<td>{i.status_txt}</td>
								<td className="actions">
									{
										checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
													<img src={EditIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
													<img src={DeleteIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
											<Tooltip title={i.status === Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}>
												<img
													style={{ width: 28, height: 28 }}
													src={ i.status == Constants.USER_STATUS.ACTIVE ? SwitchOnIcon : SwitchOffIcon }
													onClick={ () => this.suspend(i) }
													alt="Suspender/Activar"
												/>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					}} />
			</div>
		)
	}
}

const UserAnimals = ({ item, onEdit, onClose }: any) => {

	const { farm, pet } = useMemo(() => {
		const farm = item?.user_animals?.filter((item: any) => item?.type === Constants.ANIMAL.TYPE.FARM);
		const pet = item?.user_animals?.filter((item: any) => item?.type === Constants.ANIMAL.TYPE.PET);
		return { farm, pet };
	}, [item]);

	return (
		<div className="modal-show-animals">
			<div className="header">
				<p className="title">Animales</p>
				<button className="close" onClick={onClose}>
					<img src={CloseIcon} alt="Cerrar" />
				</button>
			</div>
			<p className="section-title">Mascota</p>
			<div className="animal-list">
				{pet?.map((item: any, index: number) => (
					<span key={index} className="animal-item">{ item?.name }</span>
				))}
			</div>
			<p className="section-title">Animales de granja</p>
			<div className="animal-list">
				{farm?.map((item: any, index: number) => (
					<span key={index} className="animal-item">{ item?.name }</span>
				))}
			</div>
			<div className="actions">
				<button onClick={onEdit}>
					<img src={EditIcon} alt="Editar" />
					<span>Editar</span>
				</button>
			</div>
		</div>
	)
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(User);